import { IApplicationState } from '../../types/redux';

export const selectProducts = (state: IApplicationState) => {
  return state.analytics.products;
};
